<template>
  <div class="achievement-preview">
    <el-form  label-position="left"   :model="form" size="small">
      <el-row>
      <el-col :span="12">
      <el-form-item label-width="20px">
        <el-select filterable v-model="form.orgRec_id" clearable placeholder="请选择推荐单位" size="small" style="width: 100%;" @change="handleSelectChange">
              <el-option :label="item.user_name" :value="item.id" v-for="(item,index) in unitList" :key="index"></el-option>

              </el-select>
      </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item label-width="20px">
        <el-select filterable v-model="form.personRec_id" clearable placeholder="请选择推荐个人" size="small" style="width: 100%;" @change="handleSelectChange">
              <el-option :label="item.user_name" :value="item.id" v-for="(item,index) in individualList" :key="index"></el-option>

              </el-select>
      </el-form-item>
    </el-col>
    </el-row> 
    <el-row>
      <el-col :span="12">
        <el-form-item label-width="20px">
          <el-select filterable v-model="form.scope" clearable placeholder="请选择成果所属领域" style="width: 100%;" @change="handleSelectChange">
            <el-option :label="item.title" :value="item.id" v-for="(item,index) in dictList" :key="index"></el-option>

              </el-select>
      </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item label-width="20px">
        <el-input v-model="form.org_name"  placeholder="请输入成果申报单位名称" @input="handleInput"></el-input>
      </el-form-item>
    </el-col>
    </el-row>

    <el-row>
      <el-col :span="12">
        <el-form-item label-width="20px">
        <el-input v-model="form.declarant_name_name"  placeholder="请输入成果名称或申报人名称" @input="handleInput"></el-input>
      </el-form-item>
    </el-col>
    <el-col :span="12">
      <el-form-item  label-width="20px">
        <el-date-picker
      v-model="dateValue"
      style="width: 100%;"
      type="daterange"
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      value-format="yyyy-MM-dd"
      @change="handleDateChange">
    </el-date-picker>

      </el-form-item>
    </el-col>
    </el-row>

    </el-form>
    <el-table
      :data="tableData"
      border
      style="width: 100%"
      class="custom-table">
      <el-table-column prop="name" width="280" label="成果名称" align="center"> </el-table-column>
      <el-table-column prop="org_name" width="280" label="申报单位" align="center"> </el-table-column>
      <el-table-column prop="add_date" width="200" label="提交时间" align="center"> </el-table-column>
      <el-table-column prop="date" width="200" label="操作" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleRow(scope.row,'look')">预览</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="paginBox">
      <div class="countNumber">
        共{{ total }}条
      </div>
      <div class="rightPagin">
        <el-pagination @size-change="sizePagination" @current-change="currentPagination"
          :page-size="filter.pageSize" background layout="prev, pager, next" :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 预览弹框 -->
    <AchievementPreviewDialog ref="previewDialog" />
  </div>
</template>

<script>
import AchievementPreviewDialog from '@/views/bgManage/components/AchievementPreviewDialog.vue'

export default {
  name: 'FirstConferenceAchievements',
  components: {
    AchievementPreviewDialog
  },
  data() {
    return {
      total: 0,
      dateValue:'',
      form: {
        orgRec_id:'',
        personRec_id:'',
        scope:'',
        org_name:'',
        declarant_name_name:'',
        start_date:'',
        end_date:''
      },
      filter: {
        type:2,
        currPage: 1,
        pageSize: 7,
        orgRec_id:'',
        personRec_id:'',
        scope:'',
        org_name:'',
        declarant_name_name:'',
        start_date:'',
        end_date:''
      },
      dictList:[],
      unitList:[],
      individualList:[],
      tableData: [],
      debounceTimer: null
    }
  },
  created() {
    this.getList();
    this.getRecommendUnitList();
  },
  methods: {
    getRecommendUnitList() {
      this.$API.getDict({pid:66}).then(res => {
        this.dictList = res.data
      })
      this.$API.getLoginRecommendList({identify:1}).then(res => {
        this.unitList = res.data
      })
      this.$API.getLoginRecommendList({identify:2}).then(res => {
        this.individualList = res.data
      })
    },
    sizePagination(e) {
      this.filter.currPage = e
      this.getList()
    },
    currentPagination(e) {
      this.filter.currPage = e
      this.getList()
    },
    handleRow(row, type) {
      if (type === 'look') {
        this.$refs.previewDialog.open(row.xid)
      }
    },
    // 输入框防抖处理
    handleInput() {
      // 清除之前的定时器
      if (this.debounceTimer) {
        clearTimeout(this.debounceTimer)
      }
      // 设置新的定时器，500ms 后执行搜索
      this.debounceTimer = setTimeout(() => {
        this.handleFilterChange()
      }, 500)
    },
    // 选择框变化时立即搜索
    handleSelectChange() {
      this.handleFilterChange()
    },
    // 日期选择器变化时立即搜索
    handleDateChange() {
      this.handleFilterChange()
    },
    // 统一处理筛选变化
    handleFilterChange() {
      console.log(this.filter);
      this.filter.currPage = 1;
      this.filter.org_name = this.form.org_name;
      this.filter.recommend_state = this.form.recommend_state;
      this.filter.start_date = this.dateValue ? this.dateValue[0] : '';
      this.filter.end_date = this.dateValue ? this.dateValue[1] : '';
      this.filter.orgRec_id = this.form.orgRec_id;
      this.filter.personRec_id = this.form.personRec_id;
      this.filter.scope = this.form.scope;
      this.filter.declarant_name_name = this.form.declarant_name_name;
      this.getList();
    },
    getList() {
      this.$API.getAchievementList(this.filter).then(res => {
        this.tableData = res.data.list;
        this.total = res.data.pageInfo.allRows;
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
  color: #303133;
}

::v-deep .el-table th.el-table__cell{
  background: #F2F5FB !important;
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #595959;
}

.countNumber {
  font-family: Microsoft YaHei, Microsoft YaHei;
  font-weight: 400;
  font-size: 14px;
  color: #515A6E;
}
.paginBox {
  display: flex;
  justify-content: end;
  padding: 0 20px 20px 0;
  align-items: center;
  margin-top: 20px;
  width: 100%;
}

::v-deep .el-pagination.is-background .btn-prev {
  background: none;
}

::v-deep .el-pagination .btn-next .el-icon {
  font-size: 18px;
}

::v-deep .el-pagination .btn-prev .el-icon {
  font-size: 18px;
}

::v-deep .btn-next {
  width: 36px;
  height: 36px;
  background-color: #FFFFFF !important;
  border-radius: 3px 3px 3px 3px;
  border: 1px solid #E5E5E5;
}

::v-deep .btn-prev {
  width: 36px;
  height: 36px;
  background-color: #FFFFFF !important;
  border-radius: 3px 3px 3px 3px;
  border: 1px solid #E5E5E5;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #FFFFFF;
  border-radius: 3px 3px 3px 3px;
  border: 1px solid #2F86FF;
  font-weight: 400;
  font-size: 14px;
  color: #2F86FF;
  text-align: center;
  font-style: normal;
  text-transform: none;
}

::v-deep .el-pagination.is-background .el-pager li {
  border-radius: 3px 3px 3px 3px;
  border: 1px solid #B4B4B4;
  background: none;
  width: 36px;
  height: 36px;
  font-weight: 400;
  font-size: 14px;
  color: #313131;
  text-align: center;
  font-style: normal;
  text-transform: none;
  line-height: 35px;
}
</style>
